export const PASSWORD_MAX = 128;
export const ADDRESS_MAX = 255;
export const POSTCODE_MAX = 4;
export const STATE_MAX = 100;
export const PMS_DOCTOR_ID_MAX = 100;
export const PMS_EDI_MAX = 100;
export const PMS_NAME_MAX = 255;
export const CLINIC_NAME_MAX = 255;
export const ORG_NAME_MAX = 255;
export const PROVIDER_ID_MAX = 100;
export const NOTES_MAX = 1024;
export const COMPANY_SIZE_MAX = 50;
export const ROLE_TITLE_MAX = 100;
export const TIMEZONE_MAX = 50;
export const DATE_FORMAT_MAX = 20;
export const USERNAME_MAX = 50;
export const USERNAME_MIN = 1;
